import { observer } from 'mobx-react';
import { L, T } from '../../../../../Translations';

interface Props {
  date: Date;
}

function StartOn({ date }: Props) {
  if (date < new Date()) {
    return (
      <T kind="Started <date/>" date={<L localizeable={date} format="short-month-day-year" />} />
    );
  } else {
    return (
      <T kind="Starts <date/>" date={<L localizeable={date} format="short-month-day-year" />} />
    );
  }
}

export default observer(StartOn);
